module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Devices/Mouse-b0211140c3b2ec7707fba55122a6353a4e084e6345f070a4d216704203599b8b.svg";